// @flow

export const EVENT_PAGE_LOAD: 'tracking/PAGE_LOAD' = 'tracking/PAGE_LOAD';
export const EVENT_PAGE_VIEW: 'tracking/PAGE_VIEW' = 'tracking/PAGE_VIEW';
export const EVENT_ADD_PAYMENT_INFO: 'tracking/EVENT_ADD_PAYMENT_INFO' =
  'tracking/EVENT_ADD_PAYMENT_INFO';
export const EVENT_ECOMMERCE: 'tracking/EVENT_ECOMMERCE' =
  'tracking/EVENT_ECOMMERCE';
export const EVENT_LEADS: 'tracking/EVENT_LEADS' = 'tracking/EVENT_LEADS';
export const EVENT_CALL_TO_BOOK: 'tracking/EVENT_CALL_TO_BOOK' =
  'tracking/EVENT_CALL_TO_BOOK';
export const EVENT_VOUCHER: 'tracking/EVENT_VOUCHER' = 'tracking/EVENT_VOUCHER';
export const EVENT_INPUT_ERROR: 'tracking/EVENT_INPUT_ERROR' =
  'tracking/EVENT_INPUT_ERROR';
export const EVENT_PSD2_AUTH: 'tracking/EVENT_PSD2_AUTH' =
  'tracking/EVENT_PSD2_AUTH';
export const EVENT_INSURANCE_CONFIRM: 'tracking/EVENT_INSURANCE_CONFIRM' =
  'tracking/EVENT_INSURANCE_CONFIRM';
export const EVENT_CARRENTAL_CLICK = 'tracking/EVENT_CARRENTAL_CLICK';
export const EVENT_TRANSFER_CLICK = 'tracking/EVENT_TRANSFER_CLICK';
export const EVENT_TRANSFER_LOADED = 'tracking/EVENT_TRANSFER_LOADED';
export const EVENT_SOI_CHANGED = 'tracking/EVENT_SOI_CHANGED';
export const EVENT_SCARCITY_LOAD = 'tracking/LOAD';
export const EVENT_SCARCITY_CLICK = 'tracking/CLICK';
export const EVENT_BDV_SPLIT = 'tracking/EVENT_BDV_SPLIT';
export const EVENT_PARTNER_RATING = 'tracking/EVENT_PARTNER_RATING';
export const EVENT_EXITLAYER_LOAD = 'tracking/EVENT_EXITLAYER_LOAD';
export const EVENT_EXITLAYER_CLICK = 'tracking/EVENT_EXITLAYER_CLICK';
export const EVENT_TOOLTIP = 'tracking/TOOLTIP';
export const EVENT_COPY_VOUCHER = 'tracking/COPY_USERS_VOUCHER';
export const EVENT_SHOWN_VOUCHER = 'tracking/SHOWN_USERS_VOUCHER';
export const EVENT_PICTURE_GALLERY_CLICK = 'tracking/PIC_GALLERY_CLICK';
export const EVENT_USER_GALLERY_CLICK = 'tracking/PIC_GALLERY_CLICK';
export const EVENT_CUSTOMER_IS_TRAVELER = 'tracking/EVENT_CUSTOMER_IS_TRAVELER';
